import React, { useContext } from "react";
export const InFormationContext = React.createContext({
    inFormation: {
        title: "",
    },
    setInFormation: (title) => { },
});
export const useInFormation = () => {
    const context = useContext(InFormationContext);
    if (!context) {
        throw new Error("useInFormation must be used only within the InFormationContext");
    }
    return context;
};
